import { createPortal } from 'react-dom';
import {

  ModalContent,
  ModalOverlay,
  CloseBtn,
  ModalOverlayLeft,
  ModalOverlayRight,
} from './ModalBoard.styled';
import { useRef } from 'react';
const modalRoot = document.querySelector('#root-module');

const ModalBoard = ({ children, onClose, classS, expires }) => {


  const handleContentClick = event => {
    event.stopPropagation();
  };
 const shouldClose = useRef(false);

  const handleMouseDown = (e) => {
    shouldClose.current = e.target === e.currentTarget;
  };
 const handleMouseUp = (e) => {
    if (
      shouldClose.current &&
      e.target === e.currentTarget
    ) {
      onClose();
    }

    shouldClose.current = false;
  };


  return createPortal(
    <ModalOverlay     onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}>
      <ModalOverlayLeft />
      <ModalOverlayRight style={{ justifyContent: classS === 'board6' ? 'end' : "start" }}>
        <ModalContent onClick={handleContentClick} className={classS} expires={expires ? 'true' : ''} >

          <CloseBtn onClick={onClose} />

          {children}
        </ModalContent>
      </ModalOverlayRight>
    </ModalOverlay>,
    modalRoot
  );
};

export default ModalBoard;
